import request from "./request";
/*首页快速发布需求*/
export function linkOur(data) {
  return request.post("/obt/saveVipCorpApply", data);
}
